import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { DealerDto, DealerMenuItemDto } from '@core/dtos'
import { DealerHttp, GameHttp } from '@core/https'
import { AccountService, WebSocketService } from '@core/services'
import { RoutePathEnum } from '@shared/enums'

import { ModalService } from '@shared/services'
import { MenuCardLandscapeComponent } from './menu-card-landscape/menu-card-landscape.component'
import { MenuCardComponent } from './menu-card/menu-card.component'
import { MenuCardDeactivatedComponent } from './menu-card-deactivated/menu-card-deactivated.component'
import { MenuCardLandscapeDeactivatedComponent } from './menu-card-landscape-deactivated/menu-card-landscape-deactivated.component'

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MenuCardComponent,
    MenuCardLandscapeComponent,
    MenuCardDeactivatedComponent,
    MenuCardLandscapeDeactivatedComponent,
  ],
  providers: [DealerHttp],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.sass',
})
export class MenuComponent implements OnInit {
  dealers: DealerMenuItemDto[] = []

  constructor(
    private _gameHttp: GameHttp,
    private _webSocketService: WebSocketService,
    private _modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this._gameHttp.getPlayerMenuInitData().subscribe((i) => {
      this.dealers = i.dealerMenuItems

      this.listenToDealerUpdates()
    })
  }

  closeModal() {
    this._modalService.closeTableInfoModal()
  }

  listenToDealerUpdates() {
    this.dealers.forEach((dealer) =>
      this._webSocketService.listenToPotBonusUpdate(dealer.id, (i) => {
        dealer.potBonus = i.amount
      }),
    )
  }
}
